import { EventEmitter } from "events";
import { BPMMedia, ContentType, BPMAlbum } from 'bpm-web-generic';
import { apiCrateToBPMCrate } from "src/transformer";
import * as uuid from "uuid";
import { crateAPI } from "src/api/config";

export class CrateManager extends EventEmitter {
    private static _instance = new CrateManager()
    private crate: BPMAlbum[]
    public static instance() {
        return CrateManager._instance;
    }

    private constructor() {
        super();
    }

    public downloadCrate(type?: ContentType | 'all', category?: string) {
        const token = uuid.v4()
        return crateAPI.generateOnlineCrateZip(location.pathname, `music`, token, category).then(({ data }) => {
            Promise.all([crateAPI.downloadOnlineCrateById(data.id), this.loadCrate()]).then(([{ data }]) => {
                window.location.assign(data.url!)
            })
            return true;
        })
    }

    public loadCrate() {
        return crateAPI.getOnlineCrate('music').then(({ data: crate }) => {
            this.crate = apiCrateToBPMCrate(crate);
            this.emit('crate-loaded', this.crate)
            return this.crate
        })
    }

    public addToCrate(media: BPMMedia) {
        return crateAPI.addMediaToOnlineCrate(media.id as number).then(({ data: crate }) => {
            this.crate = apiCrateToBPMCrate(crate)
            this.emit('crate-loaded', this.crate)
            return this.crate
        })
    }

    public clearCrate(type?: ContentType | 'all', category?: string) {
        return crateAPI.clearOnlineCrate(`music`, category).then(({ data: crate }) => {
            this.crate = apiCrateToBPMCrate(crate);
            this.emit('crate-loaded', this.crate)
            return this.crate
        })
    }

    public removeFromCrateLocal(media: BPMMedia) {
        this.crate = this.crate.filter(t => t.media[0].id != media.id);
        this.emit('crate-loaded', this.crate)
    }

    public removeFromCrate(media: BPMMedia) {
        return crateAPI.removeFromOnlineCrate(media.id as number).then(() => {
            this.removeFromCrateLocal(media)
            return this.crate
        })
    }
}


// WEBPACK FOOTER //
// ./src/manager/CrateManager.ts